module.exports = __webpack_public_path__ + "assets/img/41d2b07df005b10768420f2f5ba7942d.png";